import { Breakfast2, Dinner, Lunch } from '@hungryroot/icons';
import { type ServingSize } from '@hungryroot/rest';
import {
  MAX_DINNER_RECIPES_2_SERVINGS,
  MAX_DINNER_RECIPES_4_SERVINGS,
  MIN_DINNER_RECIPES,
} from '../defs/dinner';
import { MAX_LUNCH_SERVINGS, MIN_LUNCH_SERVINGS } from '../defs/lunch';

import {
  BREAKFAST_MEAL_CONTAINER_ID,
  DINNER_CONTAINER_ID,
  LUNCH_CONTAINER_ID,
} from '../utils/utils';

export const THREE_FIVE_SERVING_SIZE_PRICING_VERSION = 19;

export function getEditContainerQuantityBlockContent(
  containerId: number,
  nextServingSize?: ServingSize,
  pricingVersion?: number
) {
  switch (containerId) {
    case BREAKFAST_MEAL_CONTAINER_ID:
      return {
        min: 0,
        max: 10,
        inputLabel: 'Servings',
        modalBody:
          'Breakfast can be single serving or extend over multiple days, like a bag of bagels for the week.',
        icon: <Breakfast2 />,
      };
    case LUNCH_CONTAINER_ID:
      return {
        min: MIN_LUNCH_SERVINGS,
        max: MAX_LUNCH_SERVINGS,
        inputLabel: 'Servings',
        modalBody:
          'Lunch can be single serving or extend over multiple days, like using a loaf of bread for sandwiches.',
        icon: <Lunch />,
      };
    case DINNER_CONTAINER_ID:
      return {
        min: MIN_DINNER_RECIPES,
        max:
          nextServingSize === 2
            ? MAX_DINNER_RECIPES_2_SERVINGS
            : MAX_DINNER_RECIPES_4_SERVINGS,
        inputLabel: 'Recipes',
        modalBody:
          pricingVersion === THREE_FIVE_SERVING_SIZE_PRICING_VERSION
            ? 'We’ll send easy 2-6 ingredient recipes that come in 2 to 5 servings.'
            : 'We’ll send easy 2-6 ingredient recipes that come in 2 or 4 servings.',
        icon: <Dinner />,
      };
    default:
      return null;
  }
}
